import React, { Component } from "react";
import "./DocumentView.scss";
import Modal from "react-bootstrap/Modal";
import closeIcon from "../../assets/close.svg";
import PDFViewer from "../PDFViewer/PDFViewer";
import DocumentAbstractViewMode from "./DocumentAbstractViewMode/DocumentAbstractViewMode";
import ThreeDot from "../../assets/icons/three_dots.svg";
import filePDF from "../../assets/icons/file-pdf-24.svg";
import Dropdown from "react-bootstrap/Dropdown";
import BulkDragAndDrop from "../BulkUpload/BulkDragAndDrop/BulkDragAndDrop";
import BulkFileItem from "../BulkUpload/BulkFileItem/BulkFileItem";
import { v4 } from "uuid";
import { gql } from "@apollo/client";
import { notify } from "../Notify/Notify";
import { apolloClient, uploadClient } from "../../index";
import SharedIcon from "../UI/SharedIcon/SharedIcon";
import ReminderModal from "../BulkUpload/ReminderModal/ReminderModal";
import DeleteSubfile from "./DeleteSubfile/DeleteSubfile";
import DocumentViewFooter from "./DocumentViewFooter/DocumentViewFooter";
import ReplaceFileModal from "./ReplaceFileModal/ReplaceFileModal";
import DeleteModal from "../DeleteModal/DeleteModal";

// Animation import
import UseAnimations from "react-useanimations";
import loading from "react-useanimations/lib/infinity";
import AddEditTagModal from "../TagsManagement/AddEditTagModal/AddEditTagModal";

class DocumentView extends Component {
  state = {
    uploadedFile: undefined,
    dataSaved: false,
    anyUpdateMade: false,
    viewOnly: true,
    abstractJson: [],
    currentAbstractJson: [],
    documentTypes: [],
    listTags: [],
    listCategories: [],
    isDocumentAbstractUpdated: false,
    documentId: null,
    openReplaceFileModal: false,
    openReminderModal: false,
    calenderDates: null,
    selectedFileObj: null,
    primaryDocument: null,
    isSubFilesLoading: true,
    subFiles: [],
    isSubFileSelected: false,
    fileUrl: undefined,
    showSubfileDeleteModal: false,
    showFieldDeleteModal: false,
    selectedSectionId: null,
    selectedField: null,
    newlyAddedFields: [],
    isPrimaryDocumentUpdated: false,
    isAbstractJsonUpdated: false,
    isAddTagModalOpen: false,
    // overview : "",
  };

  threeDotMenu = React.forwardRef(({ onClick }, ref) => (
    <button
      className="dropdown custom-dropdown ic-ghost"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <img className="dropdown-toggle" src={ThreeDot} alt="Three dots" />
    </button>
  ));

  downloadFile = (url, title) => {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const blobURL = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobURL;
        a.style = "display: none";

        a.download = title;
        document.body.appendChild(a);
        a.click();
      })
      .catch((e) => console.log(e));
  }

  downloadFileHandler = (isPrimaryFile = true, subFileID) => {
    if(isPrimaryFile) {
      this.downloadFile(this.props.fileUrl, this.props.title)
    } else {
      if(subFileID) {
        let subFiles = [...this.state.subFiles];
        let subFile = subFiles.find((subFile) => subFile.id === subFileID);

        if(subFile) {
          this.downloadFile(subFile.fileUrl, subFile.fileName)
        }
      }
    } 
  };

  handleDrop = (files) => {
    for (var i = 0; i < files.length; i++) {
      if (!files[i].name) return;
      const fileNameArray = files[i].name.split(".");
      const ext = fileNameArray[fileNameArray.length - 1];
      if (ext === "pdf" || ext === "xls" || ext === "doc") {
        
        this.setState({ uploadedFile: files[i],
          // primaryDocument: primaryDocument, 
          fileUrl: URL.createObjectURL(files[i]) });

        break;
      }
    }
  };

  hasValidValues = () => {
    const overiewTabIndex = this.state.abstractJson.findIndex((tab) => tab.tabTitle === 'Overview');
    if (
      !this.state.abstractJson[overiewTabIndex].tabSections[0].sectionFields[1].fieldValue ||
      this.state.abstractJson[overiewTabIndex].tabSections[0].sectionFields[1].fieldValue ===
        "Select one"
    ) {
      return false;
    }

    return this.state.uploadedFile || this.state.isDocumentAbstractUpdated;
  };

  componentDidMount() {
    this.loadTagsAndCategories()
  }

  componentDidUpdate(prevProps) {
    if (this.props.showModal !== prevProps.showModal) {
      
      const {viewOnly, documentObj, fileUrl, showModal} = this.props
      
      if(showModal===true) {
        this.fetchSubFiles(documentObj.id)
        // Add tag options to the abstract json
        documentObj.abstractJson = this.updateAbstractJsonWithTags(documentObj.abstractJson);
        
        this.setState({
          uploadedFile: undefined,
          dataSaved: false,
          anyUpdateMade: false,
          viewOnly: viewOnly,
          primaryDocument: documentObj,
          abstractJson: [...documentObj.abstractJson] || [],
          currentAbstractJson: [...documentObj.abstractJson] || [],
          tempAbstractJson: [...documentObj.abstractJson] || [],
          isDocumentAbstractUpdated: false,
          documentId: documentObj.id,
          selectedFileObj: documentObj,
          fileUrl: fileUrl,
          isSubFileSelected: false,
          isSubFilesLoading: true,
          isFilesUploading: false,
          newlyAddedFields: [],
          isAbstractJsonUpdated: false,
        });
      } 
 
    }
  }

  updateDocumentDetails = async (status) => {
    if(status){
    try{
      this.setState({
        isFilesUploading: true
      });

      if (this.state.uploadedFile && !this.state.isDocumentAbstractUpdated) {
        // Only file replace
        const UPDATE_FILE = gql`
        mutation editDocument($file: Upload!, $documentId: UUID!, $isNewField: Boolean!, $isDocumentEdited: Boolean!, $tagId: UUID) {
          editDocument(
            file: $file
            documentId: $documentId
            isNewField: $isNewField
            isDocumentEdited: $isDocumentEdited
            tagId: $tagId
          ) {
            success
          }
        }
      `;

        const overiewTabIndex = this.state.abstractJson.findIndex((tab) => tab.tabTitle === 'Overview');

        const selectedTag =
          this.state.abstractJson[overiewTabIndex].tabSections[0].sectionFields[3];
        let tagId = this.state.listTags.filter(
          (x) => x.name === selectedTag.fieldValue
        );

        const variables = {
          file: this.state.uploadedFile,
          documentId: this.props.documentObj.id,
          isNewField: false,
          isDocumentEdited: true,
          tagId: tagId.length > 0 ? tagId[0].id : null,
        };

        const result = await uploadClient
          .mutate({
            mutation: UPDATE_FILE,
            variables: variables,
          })

        if (result.data.editDocument.success) {
                     
          this.setState({
            primaryDocument: {...this.state.primaryDocument, fileUrl: this.state.fileUrl}
          })
          // this.props.handleClose();
        } else {
          throw new Error("Oops!! some error occurred please try again.");
        }
      } else if (
        this.state.uploadedFile &&
        this.state.isDocumentAbstractUpdated
      ) {
        const overiewTabIndex = this.state.abstractJson.findIndex((tab) => tab.tabTitle === 'Overview');
        // File replace and abstract change
        const fileName =
          this.state.abstractJson[overiewTabIndex].tabSections[0].sectionFields[0].fieldValue;
        const documentType =
          this.state.abstractJson[overiewTabIndex].tabSections[0].sectionFields[1];
        let documentTypeId = documentType.options.filter(
          (x) => x.optionValue === documentType.fieldValue
        );

        const selectedTag =
          this.state.abstractJson[overiewTabIndex].tabSections[0].sectionFields[3];
        let tagId = selectedTag.options.filter(
          (x) => x.optionValue === selectedTag.fieldValue
        );
        if(selectedTag) {
          // Clear options so that backend don't store stale copy of tags
          selectedTag.options = []
        }

        const variables = {
          file: this.state.uploadedFile,
          documentId: this.props.documentObj.id,
          title: fileName,
          abstract: JSON.stringify(this.state.abstractJson),
          documentTypeId: documentTypeId[0].optionId,
          tagId: tagId.length > 0 ? tagId[0].optionId : null,
          statusId: 1, // 1 Active, 2 Draft
          isNewField: this.state.newlyAddedFields.length !== 0, 
          isDocumentEdited: this.state.isAbstractJsonUpdated,
        };

        const result = await uploadClient
        .mutate({
          mutation: gql`
            mutation editDocument(
              $file: Upload!
              $abstract: String
              $documentId: UUID!
              $title: String
              $documentTypeId: UUID
              $tagId: UUID
              $statusId: Int
              $isNewField: Boolean!
              $isDocumentEdited: Boolean!
            ) {
              editDocument(
                file: $file
                abstract: $abstract
                documentId: $documentId
                title: $title
                documentTypeId: $documentTypeId
                tagId: $tagId
                statusId: $statusId
                isNewField: $isNewField
                isDocumentEdited: $isDocumentEdited
              ) {
                success
              }
            }
          `,
          variables: variables,
        });
        if (result.data.editDocument.success) {
          
          // this.props.handleClose();
        } else {
          throw new Error("Oops!! some error occurred please try again.");
        }
        
      } else if(this.state.isDocumentAbstractUpdated && this.state.isPrimaryDocumentUpdated) {

        const overiewTabIndex = this.state.abstractJson.findIndex((tab) => tab.tabTitle === 'Overview');
        const fileName =
          this.state.abstractJson[overiewTabIndex].tabSections[0].sectionFields[0].fieldValue;
        const documentType =
          this.state.abstractJson[overiewTabIndex].tabSections[0].sectionFields[1];
        let documentTypeId = documentType.options.filter(
          (x) => x.optionValue === documentType.fieldValue
        );

        const selectedTag =
          this.state.abstractJson[overiewTabIndex].tabSections[0].sectionFields[3];
        let tagId = this.state.listTags.filter(
          (x) => x.name === selectedTag.fieldValue
        );
        if(selectedTag) {
          // Clear options so that backend don't store stale copy of tags
          selectedTag.options = []
        }

        const variables = {
          documentId: this.props.documentObj.id,
          title: fileName,
          abstract: JSON.stringify(this.state.abstractJson),
          documentTypeId: documentTypeId[0].optionId,
          tagId: tagId.length > 0 ? tagId[0].id : null,
          statusId: 1, // 1 Active, 2 Draft
          isNewField: this.state.newlyAddedFields.length !== 0,
          isDocumentEdited: this.state.isAbstractJsonUpdated,
        };

        const result = await apolloClient
        .mutate({
          mutation: gql`
            mutation editDocument(
              $abstract: String
              $documentId: UUID!
              $title: String
              $documentTypeId: UUID
              $tagId: UUID
              $statusId: Int
              $isNewField: Boolean!
              $isDocumentEdited: Boolean!
            ) {
              editDocument(
                abstract: $abstract
                documentId: $documentId
                title: $title
                documentTypeId: $documentTypeId
                tagId: $tagId
                statusId: $statusId
                isNewField: $isNewField
                isDocumentEdited: $isDocumentEdited
              ) {
                success
              }
            }
          `,
          variables: variables,
        })
        if (result.data.editDocument.success) {
          this.updateDateReminder(this.props.documentObj.id)
        } else {
          throw new Error("Oops!! some error occurred please try again.");
        }
      }

      await this.updateSubFiles()
    }
    catch (e) {
      notify("Error", e.message, "error");
    } finally {
      this.exitEditMode(true)
    }

  }
  else{
    this.handleFileOnClick(this.props.documentObj.id, true)
    this.fetchSubFiles(this.props.documentObj.id);
    this.setState({
      dataSaved: true,
      anyUpdateMade: false,
      isDocumentAbstractUpdated: false,
      viewOnly: true,
      abstractJson: [...this.props.documentObj.abstractJson],
      newlyAddedFields: [],
      isPrimaryDocumentUpdated: false,
    });
  }
  };

  updateDateReminder = (documentId) =>{
    const variables = {
      documentIdList: [documentId],
    };
    apolloClient
        .query({
          query: gql`
            query documentCalendarEvents($documentIdList: [UUID]!) {
              documentCalendarEvents(documentIdList: $documentIdList) {
                id
                dateTitle
                documentId
                documentTitle
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          if (result.data.documentCalendarEvents.length > 0) {
            this.setState({
              openReminderModal: true,
              calenderDates: result.data.documentCalendarEvents,
            });
          } 
        })
        .catch((e) => {
          notify(
            "Warning",
            "Please reach out to your IT Admin or Admin regarding empty document templates.",
            "warning"
          );
        });
  }

  saveReminderDates = (dates) => {
    const variables = {
      calendarEventList: JSON.stringify(dates),
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation dateReminderSetting($calendarEventList: String!) {
            dateReminderSetting(calendarEventList: $calendarEventList) {
              success
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        if (result.data.dateReminderSetting.success) {
          this.setState({
            openReminderModal: false,
          });
        }
      })
      .catch((e) => {
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  }

  loadDocumentTypes = () => {
    apolloClient
      .query({
        query: gql`
          query {
            templatesOfCustomer {
              id
              title
              description
              abstractJson
              status {
                id
                name
              }
              createdTs
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        let documentTypes = [];
        let listOfDocs = [];
        result.data.templatesOfCustomer.map((doc) => {
          if (doc.status.id !== "2") {
            documentTypes.push({
              ...doc,
              abstractJson: JSON.parse(doc.abstractJson),
            });

            listOfDocs.push({
              optionId: doc.id,
              optionValue: doc.title,
            });
          }
          return true;
        });

        this.state.abstractJson.map((item) => {
          if (item.tabTitle === "Overview") {
            item.tabSections.map((tab) => {
              tab.sectionFields.map((field) => {
                if (field.fieldLabel === "Document Type") {
                  field.options = [
                    {
                      optionId: "37f5caef-d0e9-4cfd-b360-ad6515a7c9e4",
                      optionValue: "Select one",
                    },
                    ...listOfDocs,
                  ];
                }
                return true;
              });
              return true;
            });
          }
          return true;
        });

        if (documentTypes.length === 0) {
          notify(
            "Warning",
            "You can not add any file without having an active document template.\nPlease add document template first.",
            "warning"
          );
        }

        this.setState({
          documentTypes: documentTypes,
        });
      })
      .catch((e) => {
        notify(
          "Warning",
          "You can not add any file without having an active document template.\nPlease add document template first.",
          "warning"
        );
      });
  };
  /**
   * Tags handling code starts
   */
  // To load tags and categories for Add tag modal
  loadTagsAndCategories = () => {
    apolloClient
      .query({
        query: gql`
          query {
            listTags {
              id
              name
              isActive
              createdTs
              modifiedTs
              category {
                id
                name
              }
            }
          }
        `,
        variables: {},
      })
      .then((tagsResult) => {
        
        const { listTags } = tagsResult.data;

        this.setState({
          listTags: listTags,
        });
      })
      .catch((e) => {
        notify(
          "Warning",
          "Oops!! some error occurred please try again.",
          "warning"
        );
      });

    // Load categories
    apolloClient
      .query({
        query: gql`
          query {
            listCategories {
              id
              name
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        const { listCategories } = result.data;
        this.setState({
          listCategories: listCategories,
        });
      })
      .catch((e) => {
        this.setState({
          listCategories: [],
        });
      });
  };

  handleAddNewTag = () => {
    this.setState({
      isAddTagModalOpen: true
    })
  }

  handleSetIsAddTagModalOpen = (isOpen) => {
    this.setState({isAddTagModalOpen: isOpen})
  }

  handleSetListCategories = (listCategories) => { 
    this.setState({listCategories: listCategories})
  }

  handleSetListTags = (listTags) => {
    this.setState(
      {
        listTags: listTags,
      },
      () => {
        this.setState((prevState, props) => ({
          abstractJson: this.updateAbstractJsonWithTags(
            prevState.abstractJson,
            listTags[listTags.length - 1]
          ),
          isDocumentAbstractUpdated: true,
          isPrimaryDocumentUpdated: true,
          isAbstractJsonUpdated: true,
        }));
      }
    );
  }

  updateAbstractJsonWithTags = (abstractJson, tag = null) => {
    let listOfTags = [];
    
    this.state.listTags.filter((tag) => tag.isActive).map((tag) => {

      listOfTags.push({
        optionId: tag.id,
        optionValue: tag.name,
        optionCategory: tag.category.name,
      });
      
      return true;
    });
    let isTagNameFieldFound = false
    abstractJson.forEach((item) => {
      if (item.tabTitle === "Overview") {
        item.tabSections.forEach((tab) => {
          tab.sectionFields.forEach((field) => {
            if (field.fieldLabel.toLowerCase() === "tag name") {
              isTagNameFieldFound = true
              
              if (tag) {
                field.fieldValue = tag ? tag.name : "Select a tag name";
              }

              field.options = [
                ...listOfTags,
              ];
            }
          });
        });
      }
    });

    if(!isTagNameFieldFound && this.state.listTags.length > 0) {
      const overiewTabIndex = abstractJson.findIndex((tab) => tab.tabTitle === 'Overview');
      // const selectedTag = this.state.primaryDocument.tag
      abstractJson[overiewTabIndex].tabSections[0].sectionFields.push({
        fieldId: v4(),
        options: [
          {
            optionId: null,
            optionValue: "Select a tag name",
          },
          ...listOfTags,
        ],
        inputType: "SearchDropdown",
        fieldLabel: "Tag Name",
        fieldValue: tag ? tag.name : "Select a tag name",
        fieldRequired: false,
      });
    }

    return abstractJson
  }

  /**
   * Tags handling code ends
   */

  addDocumentTemplateAbstract = (documentType) => {
    let selectedType = JSON.parse(
      JSON.stringify(this.state.documentTypes)
    ).filter((type) => type.title === documentType)[0];
    let parsedAbstract = [...this.state.abstractJson];
    parsedAbstract = [parsedAbstract[0]];
    if (selectedType) {
      selectedType.abstractJson.map((obj) => parsedAbstract.push(obj));
    }
    this.setState({
      abstractJson: parsedAbstract,
    });
  };

  isValidAbstract = () => {
    let fileAbstract = this.state.abstractJson
    const overiewTabIndex = this.state.abstractJson.findIndex((tab) => tab.tabTitle === 'Overview');
    if (
      !fileAbstract[overiewTabIndex].tabSections[0].sectionFields[1].fieldValue ||
      fileAbstract[overiewTabIndex].tabSections[0].sectionFields[1].fieldValue ===
        "Select one"
    ) {
      return false;
    }

    for (let fIndex = 0; fIndex < fileAbstract.length; fIndex++) {
      const fObj = fileAbstract[fIndex];
      for (let tIndex = 0; tIndex < fObj.tabSections.length; tIndex++) {
        const tabObj = fObj.tabSections[tIndex];

        for (let sIndex = 0; sIndex < tabObj.sectionFields.length; sIndex++) {
          const sectionObj = tabObj.sectionFields[sIndex];

          if (sectionObj && sectionObj.fieldRequired) {
            if (
              sectionObj.fieldValue === null
            ) {
              return false;
            }
            else if(
              !(
                sectionObj.hasOwnProperty("fieldValue") &&
                sectionObj.fieldValue.length > 0
              )
            ){
              return false;
            }
          }
        }
      }
  }
  return true;
 }

 updateAbstractValdation = () => {
   this.setState({
    isDocumentAbstractUpdated : this.isValidAbstract()
   })
 }

  updateSubFileAbstract = (value, id, isFieldValueHasMultipleValues = false) => {
    const subFiles = [
        ...this.state.subFiles
    ];

    for (let index = 0; index < subFiles.length; index++) {
      const element = subFiles[index].abstractJson[0];
      for (let index3 = 0; index3 < element.tabSections.length; index3++) {
        const tabSectionObj = element.tabSections[index3];
        for (
          let index2 = 0;
          index2 < tabSectionObj.sectionFields.length;
          index2++
        ) {
          const sectionObj = tabSectionObj.sectionFields[index2];
          if (sectionObj.fieldId === id) {
            
            subFiles[index].isEdited = true;

            if (isFieldValueHasMultipleValues) {
              if (sectionObj.hasOwnProperty("fieldValue")) {
                if (sectionObj["fieldValue"].includes(value)) {
                  sectionObj["fieldValue"] = [
                    ...sectionObj["fieldValue"],
                  ].filter((val) => val !== value);
                } else {
                  sectionObj["fieldValue"] = [
                    ...sectionObj["fieldValue"],
                    value,
                  ];
                }
              } else {
                sectionObj["fieldValue"] = [value];
              }
            } else {
              sectionObj["fieldValue"] = value;
            }
            break;
          }
        }
      }
    }

    this.setState({
      subFiles: subFiles
    }, ()=> this.updateAbstractValdation())
  }

  updateFileAbstract = (value, id, isFieldValueHasMultipleValues = false) => {
    let fileAbstract = [...this.state.abstractJson];
    for (let index = 0; index < fileAbstract.length; index++) {
      const element = fileAbstract[index];

      for (let index3 = 0; index3 < element.tabSections.length; index3++) {
        const tabSectionObj = element.tabSections[index3];
        for (
          let index2 = 0;
          index2 < tabSectionObj.sectionFields.length;
          index2++
        ) {
          const sectionObj = tabSectionObj.sectionFields[index2];
          if (sectionObj.fieldId === id) {
            if (isFieldValueHasMultipleValues) {
              if (sectionObj.hasOwnProperty("fieldValue")) {
                if (sectionObj["fieldValue"].includes(value)) {
                  sectionObj["fieldValue"] = [
                    ...sectionObj["fieldValue"],
                  ].filter((val) => val !== value);
                } else {
                  sectionObj["fieldValue"] = [
                    ...sectionObj["fieldValue"],
                    value,
                  ];
                }
              } else {
                sectionObj["fieldValue"] = [value];
              }
            } else {
              sectionObj["fieldValue"] = value;
            }
            this.setState(
              {
                abstractJson: fileAbstract,
                isPrimaryDocumentUpdated: true,
                isAbstractJsonUpdated: this.state.newlyAddedFields.findIndex(
                  (field) => field.fieldId === sectionObj.fieldId
                ) !== -1 
                  ? this.state.isAbstractJsonUpdated
                  : true,
              },
              () => this.updateAbstractValdation()
            );
            break;
          }
        }
      }
    }
  };

  dropdownValueChangeHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const id = e.target.id;

    this.updateFileAbstract(value, id);

    if (value && name === "Document Type") {
      this.addDocumentTemplateAbstract(value);
    }
  };

  fieldValueChangeHandler = (e) => {
    const value = e.target.value;
    const id = e.target.id;

    if(this.state.isSubFileSelected) {
      this.updateSubFileAbstract(value, id);
    } else {
      this.updateFileAbstract(value, id);
    }
  };

  radioValueChangeHandler = (e) => {
    const value = e.target.value;
    const id = e.target.name;

    this.updateFileAbstract(value, id);
  };

  checkboxValueChangeHandler = (e) => {
    const value = e.target.value;
    const id = e.target.name;

    this.updateFileAbstract(value, id, true);
  };

  getContentRole = (userRoleId) => {
    const document = this.props.documentObj;
    if (userRoleId === 1 || userRoleId === 2) {
      return [true, { role: "Owner" }];
    } else if (document) {
      const createUserId = document.createdBy.id;
      const logUserId = this.props.currentUserInfo.id;
      let returnedVal;
      if (logUserId === createUserId) {
        returnedVal = [true, { role: "Owner" }];
      } else {
        const sharedUsers = document.sharedDocument.map((sharedItem) => {
          return {
            id: sharedItem.user.id,
            role: sharedItem.userRole.name,
          };
        });
        const getAccess = sharedUsers.find(
          (sharedUser) =>
            sharedUser.id === logUserId &&
            (sharedUser.role === "Owner" ||
              sharedUser.role === "Collaborator" ||
              sharedUser.role === "Viewer")
        );
        returnedVal = getAccess ? [true, getAccess] : [false];
      }
      return returnedVal;
    }
  };

  handleOpenModal() {
    this.setState({
      openReplaceFileModal: true,
    });
  }

  handleCloseModal() {
    this.setState({
      openReplaceFileModal: false,
    });
  }

  handleOverview(data) {
    this.setState({
      overview: data,
    });
  }

  handleSubfileDrop = (files) => {
    let fileList = [...this.state.subFiles];
    for (var i = 0; i < files.length; i++) {
      if (!files[i].name) return;
      const fileNameArray = files[i].name.split(".");
      const ext = fileNameArray[fileNameArray.length - 1];
      if (ext === "pdf" || ext === "xls" || ext === "doc") {
        let abstractJson = [
          {
            tabId: v4(),
            tabTitle: "Overview",
            tabSections: [
              {
                sectionId: v4(),
                sectionTitle: "Sub-File details",
                sectionFields: [
                  {
                    fieldId: v4(),
                    inputType: "TextField",
                    fieldValue: files[i].name,
                    fieldLabel: "Sub-File name",
                    fieldRequired: false,
                    fieldPlaceHolder: "Sub-File name",
                  },
                  {
                    fieldId: v4(),
                    inputType: "TextArea",
                    fieldLabel: "Description",
                    fieldRequired: false,
                    fieldValue: "",
                    fieldPlaceHolder: "Description",
                  },
                ],
              },
            ],
          },
        ];

        fileList.push({
          id: Math.floor(Math.random() * 100001),
          fileName: files[i].name,
          file: files[i],
          abstractJson: abstractJson,
          isUploaded: true,
          fileUrl: URL.createObjectURL(files[i])
        });
      }
    }
    
    this.setState({ subFiles: fileList}, () => {
      if (this.state.subFiles.length === 1) {
        this.handleFileOnClick(this.state.subFiles[0].id, false);
      }
    });
  };

  handleFileOnClick = (id, isPrimaryFile = true) => {
    if(isPrimaryFile) {

      let abstract = [...this.state.abstractJson];
      let primaryDocument = {...this.state.primaryDocument};

      this.setState({
        fileUrl: primaryDocument.fileUrl,
        selectedFileObj: primaryDocument,
        currentAbstractJson: abstract,
        uploadedFile: undefined,
        isSubFileSelected: !isPrimaryFile,
      }, () => {
        this.abstractViewChild.setActiveTab();
      });

      
      
    } else {
      this.abstractViewChild.setOverviewTab();
      let fileList = [...this.state.subFiles]; //JSON.parse(JSON.stringify(this.state.subFiles));
      let isFilesListUpdated = false;
  
      if (this.state.selectedFileObj) {
        for (let index = 0; index < fileList.length; index++) {
          const fileObj = fileList[index];
          if (fileObj.id === this.state.selectedFileObj.id) {
            fileObj.abstractJson = JSON.parse(
              JSON.stringify(this.state.selectedFileObj.abstractJson)
            );
            isFilesListUpdated = true;
            break;
          }
        }
      }
  
  
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].id === id) {

          const { abstractJson, fileUrl } = fileList[i];
          const subFiles = isFilesListUpdated ? fileList : [ ...this.state.subFiles]

          this.setState({
            selectedFileObj: fileList[i],
            subFiles: subFiles,
            currentAbstractJson: abstractJson,
            isSubFileSelected: !isPrimaryFile,
            fileUrl: fileUrl,
          })
          
          break;
        }
      }
    }
  };

  handleDelete = (id) => {
    this.handleFileOnClick(id, false);

    this.setState({
      showSubfileDeleteModal: true
    })
  };

  // To fetch subfiles
  fetchSubFiles(documentId) {
    const variables = {
      documentId: documentId,
    };
    apolloClient
        .query({
          query: gql`
            query SubFilesOfDocument ($documentId: UUID!){
              subFilesOfDocument(documentId: $documentId){
                id
                file
                fileUrl
                title
                description
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {

          // Generate metadata abstract json for each subfile
          let subFiles = [];
          if (result.data.subFilesOfDocument.length > 0) {
            subFiles = result.data.subFilesOfDocument.map(({title, description, ...subfile}) => {
              return {
                ...subfile, 
                fileName: title,
                abstractJson: [
                {
                  tabId: v4(),
                  tabTitle: "Overview",
                  tabSections: [
                    {
                      sectionId: v4(),
                      sectionTitle: "Sub-File details",
                      sectionFields: [
                        {
                          fieldId: v4(),
                          inputType: "TextField",
                          fieldValue: title,
                          fieldLabel: "Sub-File name",
                          fieldRequired: false,
                          fieldPlaceHolder: "Sub-File name",
                        },
                        {
                          fieldId: v4(),
                          inputType: "TextArea",
                          fieldValue: description,
                          fieldLabel: "Description",
                          fieldRequired: false,
                          fieldPlaceHolder: "Description",
                        },
                      ],
                    },
                  ],
                },
              ]}
            })
          } 
          this.setState({
            subFiles: subFiles,
            isSubFilesLoading: false
          })
        })
        .catch((e) => {
          notify(
            "Warning",
            "Oops!! some error occurred please try again.",
            "warning"
          );
        })
        .finally(() => {
          this.setState({
            isSubFilesLoading: false
          })
        });
  }

  // To update(Add/Edit) subfiles
  updateSubFiles = async () => {
    
    const subFiles = [...this.state.subFiles];
    let updatedSubfiles = [];

    const MULTIPLE_SUBFILE_OPERATIONS = gql`
        mutation MultipleSubFileOperations(
          $documentId: UUID!,
          $uploadSubFile: [UploadSubFileKeyValueType],
          $editSubFile: [EditSubFileKeyValueType], $deleteSubFile: [DeleteSubFileKeyValueType]
        ) {
          multipleSubFileOperations
          (
            documentId: $documentId, 
            uploadSubFile: $uploadSubFile, 
            editSubFile: $editSubFile, 
            deleteSubFile: $deleteSubFile
          ) 
            {
              success
            }
        }
      `;
    
    const variables = {
      documentId: this.props.documentObj.id,
      uploadSubFile: [],
      editSubFile: [],
      deleteSubFile: []
    }

    subFiles.forEach((subFile) => {
      const updatedSubfile = {
        ...subFile, 
        fileName: subFile.abstractJson[0].tabSections[0].sectionFields[0].fieldValue,
        title: subFile.abstractJson[0].tabSections[0].sectionFields[0].fieldValue,
        description: subFile.abstractJson[0].tabSections[0].sectionFields[1].fieldValue,
      }
      

      if(subFile.isDeleted) {

        variables.deleteSubFile.push({subFileId: updatedSubfile.id})

      } else {
          if(subFile.isUploaded) {

          variables.uploadSubFile.push({
            file: updatedSubfile.file,
            title: updatedSubfile.title,
            description: updatedSubfile.description,})

        } else if(subFile.isEdited) {

          variables.editSubFile.push({
            subFileId: updatedSubfile.id,
            title: updatedSubfile.title,
            description: updatedSubfile.description,})

        } 
        
        updatedSubfiles.push(updatedSubfile)
      }
    })

    const result = await uploadClient
          .mutate({
            mutation: MULTIPLE_SUBFILE_OPERATIONS,
            variables: variables,
          });
    if(result.data.multipleSubFileOperations.success) {
      notify("Success", "file updated successfully.", "success");    
    } else {
      throw new Error("Oops!! some error occurred please try again.");
    }

    this.setState({
      subFiles: updatedSubfiles
    })
  }

  exitEditMode(anyUpdateMade = false) {
    this.setState({
      isFilesUploading: false,
      dataSaved: true,
      uploadedFile: false,
      anyUpdateMade: anyUpdateMade,
      isDocumentAbstractUpdated: false,
      viewOnly: true,
      newlyAddedFields: [],
      isPrimaryDocumentUpdated: false,
      isAbstractJsonUpdated: false,
    })
  }

  // To delete a subfile
  deleteSubfile = (id) => {
    let fileList = [...this.state.subFiles];

    for (let i = 0; i < fileList.length; i++) {

      if (fileList[i].id === id) {
      
        if (
          this.state.selectedFileObj &&
          this.state.selectedFileObj.id === id
        ) {
          this.handleFileOnClick(this.state.documentId, true);
        }
        
        if(this.state.selectedFileObj.isUploaded) {
          fileList.splice(i, 1);
        }
        else {
          fileList[i].isDeleted = true;
        }

  
        this.setState({ subFiles: fileList, showSubfileDeleteModal: false });
        break;
    
      }
    }
  }

  // to add a field to a section
  addFieldToSection = (sectionId, field) => {
    let fileAbstract = [...this.state.currentAbstractJson];
    for (let index = 0; index < fileAbstract.length; index++) {
      const element = fileAbstract[index];

      for (let index3 = 0; index3 < element.tabSections.length; index3++) {
        const tabSectionObj = element.tabSections[index3];
        if(tabSectionObj.sectionId === sectionId) {
          tabSectionObj.sectionFields.push(field)
          
          this.setState({
            currentAbstractJson: fileAbstract,
            newlyAddedFields: [...this.state.newlyAddedFields, field],
            isPrimaryDocumentUpdated: true,
          }, ()=> this.updateAbstractValdation());
          break;
        }

      }
    }
  }

  // to edit a field to a section
  editFieldInSection = (sectionId, field) => {
    let fileAbstract = [...this.state.currentAbstractJson];
    for (let index = 0; index < fileAbstract.length; index++) {
      const element = fileAbstract[index];

      for (let index3 = 0; index3 < element.tabSections.length; index3++) {
        const tabSectionObj = element.tabSections[index3];
        if(tabSectionObj.sectionId === sectionId) {

          const updateFieldIndex = tabSectionObj.sectionFields.findIndex(
            (sectionField) => sectionField.fieldId === field.fieldId
          )

          tabSectionObj.sectionFields[updateFieldIndex] = field;
          
          this.setState({
            isPrimaryDocumentUpdated: true,
            currentAbstractJson: fileAbstract
          }, ()=> this.updateAbstractValdation());
          break;
        }
      }
    }
  }

  // to delete a field from a section
  deleteFieldFromSection = (sectionId, field, confirmDelete = true) => {
    if(confirmDelete === false) {
      this.setState({
        selectedSectionId: sectionId,
        selectedField: field,
        showFieldDeleteModal: true
      })
    } else {
      let fileAbstract = [...this.state.currentAbstractJson];
      for (let index = 0; index < fileAbstract.length; index++) {
        const element = fileAbstract[index];
  
        for (let index3 = 0; index3 < element.tabSections.length; index3++) {
          const tabSectionObj = element.tabSections[index3];
          if(tabSectionObj.sectionId === this.state.selectedSectionId) {
            tabSectionObj.sectionFields = tabSectionObj.sectionFields.filter(
              (sectionField) => sectionField.fieldId !== this.state.selectedField.fieldId
            )

            this.setState({
              currentAbstractJson: fileAbstract,
              isPrimaryDocumentUpdated: true,
              showFieldDeleteModal: false,
              selectedSection: null,
              selectedField: null,
              newlyAddedFields: this.state.newlyAddedFields.filter(
                (oldField) => oldField.fieldId !== this.state.selectedField.fieldId
              )
            }, ()=> {
              this.updateAbstractValdation()});
            break;
          }
  
        }
      }
    }
  }
  
  // To check if new subfiles added 
  isSubFilesUpdated = () => this.state.subFiles.filter((subFile) => subFile.isUploaded === true || subFile.isDeleted === true)
     .length > 0
  

  render() {
    const contentAccess =
      this.getContentRole(this.props.userRoleId) &&
      this.getContentRole(this.props.userRoleId)[1];

    return (
      <Modal
        className="document-view-modal"
        size="xl"
        centered
        show={this.props.showModal}
        onHide={() => this.props.handleClose(this.state.anyUpdateMade)}
      >
        <AddEditTagModal
            {...{
              isModalOpen: this.state.isAddTagModalOpen,
              setIsModalOpen: this.handleSetIsAddTagModalOpen,
              listTags: this.state.listTags,
              listCategories: this.state.listCategories,
              setListCategories: this.handleSetListCategories ,
              setListTags: this.handleSetListTags,
              isDocumentView: true
            }}
          />
        <DeleteSubfile 
          showSubfileDeleteModal={this.state.showSubfileDeleteModal}
          subfileDeleteCloseHandler={() => this.setState({showSubfileDeleteModal: false})}
          subfileDeleteHandler={this.deleteSubfile}
          id={this.state.selectedFileObj ? this.state.selectedFileObj.id : null}
        />
        <DeleteModal 
          title="Delete Field"
          description="Are you sure you want to delete this field?"
          show={this.state.showFieldDeleteModal}
          handleClose={() => this.setState({showFieldDeleteModal: false})}
          handleDelete={this.deleteFieldFromSection}
        />
        <div className="document-view-modal-content">
          <div className="header">
            <div className="d-flex">
              <h3 className="title">{this.props.title}</h3>
              <SharedIcon 
                isFolder={false} 
                itemId={this.state.documentId} 
                showCount={true} 
                loadingArea="Document" 
                sharedItems={this.state.primaryDocument ? this.state.primaryDocument.sharedDocument : []} />
            </div>

            <div className="d-flex">
              
              {!this.props.calendarView && !this.props.archiveView? (
                this.getContentRole(this.props.userRoleId) &&
                this.getContentRole(this.props.userRoleId)[0] ? (
                  <Dropdown>
                    <Dropdown.Toggle as={this.threeDotMenu}></Dropdown.Toggle>
                    <Dropdown.Menu>
                      {contentAccess &&
                      (contentAccess.role === "Owner" ||
                        contentAccess.role === "Collaborator" ||
                        contentAccess.role === "Viewer") ? (
                        <Dropdown.Item
                          as="a"
                          onClick={this.downloadFileHandler}
                        >
                          Download
                        </Dropdown.Item>
                      ) : null}
                      {contentAccess &&
                      (contentAccess.role === "Owner" ||
                        contentAccess.role === "Collaborator") &&
                      (this.state.viewOnly || this.props.calendarView) ? (
                        <Dropdown.Item
                          as="a"
                          onClick={() => {
                            this.props.handleEdit(this.state.documentId);
                          }}
                        >
                          Edit
                        </Dropdown.Item>
                      ) : null}
                      {contentAccess &&
                      (contentAccess.role === "Owner" ||
                        contentAccess.role === "Collaborator") ? (
                        <Dropdown.Item
                          as="a"
                          onClick={() =>
                            this.props.documentHandleShare(this.props)
                          }
                        >
                          Share
                        </Dropdown.Item>
                      ) : null}
                      {contentAccess && contentAccess.role === "Owner" ? (
                        <Dropdown.Item
                          as="a"
                          onClick={() =>
                            this.props.setArchiveModalVisibility(
                              true,
                              this.props.title,
                              this.props.documentObj.id
                            )
                          }
                        >
                          Archive
                        </Dropdown.Item>
                      ) : null}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : null
              ) : null}

              <img
                className="close"
                src={closeIcon}
                alt="close"
                onClick={() => this.props.handleClose(this.state.anyUpdateMade)}
              />
            </div>
          </div>

          <div className="document-view-container">
            <div className="document-view-files">
              <div className="mt-6 ">
                <div className="document-view-files-title bold">Primary File</div>
                <BulkFileItem
                    handleOnClick={this.handleFileOnClick}
                    key={this.props?.documentObj?.id}
                    keyId={this.props?.documentObj?.id}
                    file={this.props?.title}
                    showDeleteButton={false}
                    showReplaceButton={!this.props.archiveView && !this.props.calendarView}
                    handleReplacePrimaryFile={() => {
                      this.handleOpenModal()
                    }}
                    isActive={
                      this.state.selectedFileObj
                        ? this.state.documentId === this.state.selectedFileObj.id
                        : false
                    }
                  />
              </div>
              <div className="mt-6 ">
                <div className="document-view-files-title bold">Sub-Files</div>
              </div>
              {
                !this.state.viewOnly ? (<BulkDragAndDrop isSubFileSelector={true} id={"subfile"} handleDrop={this.handleSubfileDrop}></BulkDragAndDrop>) : ""
              }
              
              <div className="mt-6 ">
                {
                this.state.isSubFilesLoading ? (
                  <div>
                      <UseAnimations
                        animation={loading}
                        autoplay={true}
                        loop={true}
                        strokeColor="Blue"
                      />
                    </div>
                ) :
                this.state.subFiles.length === 0 && this.state.viewOnly ? (
                  <div className="empty-subfiles">
                    <img src={filePDF} alt="No files added" />
                    <span className="title">No files added</span>
                  </div>
                ) :
                this.state.subFiles.map((file) => !file.isDeleted ? (
                  <BulkFileItem
                    handleDelete={this.handleDelete}
                    handleOnClick={this.handleFileOnClick}
                    key={file.id}
                    keyId={file.id}
                    isPrimaryFile={false}
                    file={file.fileName}
                    showDeleteDownloadDropdown={!this.state.viewOnly}
                    showDeleteButton={false}
                    handleDownload={this.downloadFileHandler}
                    isActive={
                      this.state.selectedFileObj
                        ? file.id === this.state.selectedFileObj.id
                        : false
                    }
                  />
                ) : null )}
              </div>
            </div>
            <div className="document-view-reader">    
              <PDFViewer
                pdfFile={this.state.fileUrl}
              />
            </div>
            <div className="document-view-abstract">
              <DocumentAbstractViewMode
                ref={(instance) => {
                  this.abstractViewChild = instance;
                }}
                parsedAbstract={this.state.currentAbstractJson}
                documentObj={this.props.documentObj}
                viewOnly={this.state.viewOnly}
                dropdownValueChangeHandler={this.dropdownValueChangeHandler}
                fieldValueChangeHandler={this.fieldValueChangeHandler}
                radioValueChangeHandler={this.radioValueChangeHandler}
                checkboxValueChangeHandler={this.checkboxValueChangeHandler}
                uploadedFile={this.state.uploadedFile}
                dataSaved={this.state.dataSaved}
                isSubFileSelected={this.state.isSubFileSelected}
                addFieldToSection={this.addFieldToSection}
                editFieldInSection={this.editFieldInSection}
                deleteFieldFromSection={this.deleteFieldFromSection}
                isCommentActive={this.props.isCommentActive}
                userRole={this.props.userRoleId}
                handleAddNewTag={this.handleAddNewTag}
                archiveView={this.props.archiveView}
              />
            </div>
          </div>
        </div>

        <DocumentViewFooter
          viewOnly={this.state.viewOnly}
          uploadedFile={this.state.uploadedFile} 
          handleCancel={() => {
            this.updateDocumentDetails(false);
            this.abstractViewChild.setActiveTab();
          }}
          handleClose={() => {
            this.props.handleClose(this.state.anyUpdateMade)
          }}
          handleSave={() => {
            this.updateDocumentDetails(true);
          }}
          saveDisabled={() => (!this.hasValidValues() && !this.isSubFilesUpdated()) || this.state.isFilesUploading}
          cancelDisabled={() => this.state.isFilesUploading}
        />

        <ReplaceFileModal
          handleOpenModal={this.state.openReplaceFileModal}
          handleCloseModal={() => this.handleCloseModal()}
          handleDrop={(files) => {
            this.handleCloseModal()
            this.handleDrop(files)
          }}
          overviewData={this.state.currentAbstractJson}
        />

        <ReminderModal
          openReminderModal={this.state.openReminderModal}
          documents={this.state.calenderDates}
          saveReminderDates={this.saveReminderDates}
          closeModal={() => {
            this.setState({
              openReminderModal: false,
            });
          }}
        />

        {this.props.showShareModal || this.props.showArchiveModal ? (
          <div className="add-backdrop"></div>
        ) : null}
      </Modal>
    );
  }
}

export default DocumentView;
